import styled from 'styled-components';

export const SocialIconImage = styled.img`
  width: 30px;
  height: 30px;
`;
